import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getZoneAvailableColumns } from './api';

export const path = '/zone/list';

const PageZoneList: React.FC = (props) => {
  const ZoneList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getZoneAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ZoneList {...props} />;
};

export default PageZoneList;
